<template>
  <div class="container doc">
    <h3 class="tit" style="margin: 30px 0 20px">娱乐焦点</h3>
    <article v-if="article" class="artCon">
      <h1>{{ article.title }}</h1>
      <div class="article">
        <p><strong>导读：</strong>{{ article.summary }}</p>
        <p class="meta">资料整理时间：{{ article.updatedAt }}，热点信息以官方页面与权威媒体最新公开内容为准。</p>
        <p v-for="(paragraph, index) in article.paragraphs" :key="`paragraph-${index}`">
          {{ paragraph }}
        </p>
        <p><strong>本条看点：</strong></p>
        <ul class="article-list">
          <li v-for="(item, index) in article.highlights" :key="`highlight-${index}`">
            {{ item }}
          </li>
        </ul>
        <p><strong>最新资源：</strong></p>
        <ul class="article-list">
          <li v-for="(item, index) in article.resources" :key="`resource-${index}`">
            <a
              class="resource-link"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'EntertainmentArticle',
  props: {
    article: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.meta {
  color: #999999;
  font-size: 15px;
}

.article-list {
  margin: 0 0 20px;
  padding-left: 24px;
}

.article-list li {
  margin-bottom: 10px;
}

.resource-link {
  color: #20a0ff;
}

.resource-link:hover {
  text-decoration: underline;
}
</style>
